import { Col, Row } from 'antd';
import Link from 'next/link';
import { ReactElement } from 'react';
import styled from 'styled-components';

import EmojiLove from '../assets/icons/EmojiLove';
import EmojiStars from '../assets/icons/EmojiStars';
import EmojiThanks from '../assets/icons/EmojiThanks';
import businessstocck from '../assets/images/LandingPage/businessstocck.png';
import EmojiBackground1 from '../assets/images/LandingPage/emojiBackground1.svg';
import integrationsImage from '../assets/images/LandingPage/integrations.png';
import rememberPresentation from '../assets/images/LandingPage/rememberPresentation.png';
import theme from '../assets/theme';
import { Button } from '../components/_atoms/Button';
import { Center } from '../components/_atoms/Center';
import MaxWidthContainer from '../components/_atoms/MaxWidthContainer';
import ImageAndText from '../components/_molecules/ImageAndText';
import BusinessCustomers from '../components/_organisms/BusinessCustomers';
import { NextPageWithLayout } from '../components/layouts';
import LandingPageLayout from '../components/layouts/LandingPageLayout';
import { useMarketingMetrics } from '../providers/PlausibleAnalyticsProvider';

const CustomersSection = () => {
  return (
    <MaxWidthContainer style={{ marginTop: 40, marginBottom: 40 }}>
      <Center style={{ marginBottom: 40 }}>
        <span style={{ color: theme.colors.black, fontWeight: 'bold', fontSize: 24 }}>
          People from these amazing companies use Curipod
        </span>
      </Center>
      <BusinessCustomers />
    </MaxWidthContainer>
  );
};

const BusinessPage: NextPageWithLayout = () => {
  const { track } = useMarketingMetrics();
  return (
    <>
      <CustomersSection />
      <MaxWidthContainer>
        <MaxWidthContainer>
          <StatementTitle>What is Curipod?</StatementTitle>
        </MaxWidthContainer>
        <Row
          gutter={[32, 42]}
          style={{ paddingTop: 40, paddingBottom: 40 }}
          justify="center"
        >
          <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
            <ItemContainer>
              <EmojiLove />
              <h3>Create</h3>
              <p>
                Create interactive lessons or find premade templates for meetings,
                lessons, trainings and more.
              </p>
            </ItemContainer>
          </Col>
          <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
            <ItemContainer>
              <EmojiThanks />
              <h3>Engage</h3>
              <p>
                Participants connect with their own device - answering questions, voting,
                creating sketches and more - visualize the responses to create great
                discussions
              </p>
            </ItemContainer>
          </Col>
          <Col xs={24} sm={12} md={8} lg={8} xl={8} xxl={8}>
            <ItemContainer>
              <EmojiStars />
              <h3>Impact</h3>
              <p>
                Communicate effectively, align your team and bring out the best ideas from
                everyone
              </p>
            </ItemContainer>
          </Col>
        </Row>
      </MaxWidthContainer>
      <ImageAndText
        image={rememberPresentation.src}
        title="Make a lesson people remember"
        direction="rtl"
        description="People process information 10x faster when actively engaged. Curipod helps you engage everyone. "
      />

      <StatementSection text="Combine Curipod with your favorite tools" />
      <MaxWidthContainer
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: 50,
        }}
      >
        <img
          src={integrationsImage.src}
          style={{ height: '100%', width: '100%', maxWidth: '300px' }}
        />
      </MaxWidthContainer>

      <StatementSection text="When are you facilitating your next workshop or lesson?" />
      <MaxWidthContainer
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <Link passHref href={'/signup'}>
          <a>
            <Button
              onClick={() => {
                track('Navigate.SignUp');
              }}
              type="primary"
            >
              Get started now for free
            </Button>
          </a>
        </Link>
      </MaxWidthContainer>

      <MaxWidthContainer
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: 100,
        }}
      >
        <></>
      </MaxWidthContainer>
    </>
  );
};

const ItemContainer = styled.div`
  position: relative;
  border-radius: 10px;
  background-image: url(${EmojiBackground1.src});
  background-size: cover;
  padding: 40px 20px;
  height: 100%;
  text-align: center;
  p {
    font-weight: 500;
    font-size: 16px;
    color: ${theme.colors.white};
  }
  svg {
    position: absolute;
    top: -18%;
    left: 50%;
    transform: translateX(-50%);
    height: 80px;
    width: 80px;
  }
  h3 {
    color: ${theme.colors.white};
    font-size: 30px;
  }
`;

const StatementSection = ({
  text,
  style,
}: {
  style?: React.CSSProperties;
  text: string;
}) => {
  return (
    <MaxWidthContainer style={style}>
      <StatementTitle>{text}</StatementTitle>
    </MaxWidthContainer>
  );
};
const StatementTitle = styled.h3`
  text-align: center;
  font-weight: 500;
  color: ${theme.colors.black};
  padding-top: 45px;
  padding-bottom: 45px;
  font-size: 32px;
  max-width: 700px;
  margin: auto;
  @media ${theme.device.tablet} {
    font-size: 28px;
  }
  @media ${theme.device.mobileL} {
    font-size: 22px;
  }
`;

BusinessPage.getLayout = function getLayout(page: ReactElement) {
  return (
    <LandingPageLayout
      title="Engage everyone with interactive lessons"
      subTitle="Lead lessons and workshops with more participation, less stress and better outcomes"
      primaryActionText="Sign up - It's free"
      image={businessstocck}
    >
      {page}
    </LandingPageLayout>
  );
};

export async function getStaticProps() {
  return {
    props: {},
  };
}
export default BusinessPage;
